import ArtistAdmin      from "@/layouts/navigation/components/AdminArtist";
import AdminArtistDetails     from "@/layouts/navigation/components/AdminArtistDetails";
import Inventory        from "@/layouts/navigation/components/Inventory";
import ArtistsAll       from "@/pages/gallery-profile-options/artists-management";
import ArtistDetails    from "@/pages/gallery-profile-options/artists-management/virtual-list/artist-mgmt-card/artist-details/artist-details";
import InventoryAvailable from "@/pages/gallery-profile-options/inventory-available";
import InventoryPending   from "@/pages/gallery-profile-options/inventory-pending";
import InventorySold      from "@/pages/gallery-profile-options/inventory-sold";
import Referrals          from "@/pages/gallery-profile-options/referrals";

const GalleryProfileOptions = [
  { path: "/profile/referrals", element: <Referrals/> },

  {
    element: <Inventory/>,
    children: [
      { path: "/inventory/available", element: <InventoryAvailable/> },
      { path: "/inventory/pending",   element: <InventoryPending/> },
      { path: "/inventory/sold",      element: <InventorySold/> },
    ],
  },

  {
    element: <ArtistAdmin/>,
    children: [
      { path: "/my-artists", element: <ArtistsAll/> },
    ],
  },
  {
    element: <AdminArtistDetails/>,
    children: [
      { path: "/my-artists/:id", element: <ArtistDetails/> }
    ],
  },
];

export default GalleryProfileOptions;
